import { render, staticRenderFns } from "./App-block-coupon.vue?vue&type=template&id=ebd4490a&scoped=true&"
import script from "./App-block-coupon.vue?vue&type=script&lang=ts&"
export * from "./App-block-coupon.vue?vue&type=script&lang=ts&"
import style0 from "./App-block-coupon.vue?vue&type=style&index=0&id=ebd4490a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd4490a",
  null
  
)

export default component.exports